<template lang="pug">
  .evaluatingGiftOptions
    .text-block.graph-info(data-animate="true")
      .bar.one
        h2 66%
        .title All shoppers
      .bar.two
        h2 88%
        .title Ages 18&#8212;24
      .bar.three
        h2 87%
        .title Ages 25&#8212;34
    .text-block.one(data-animate="true")
      h4 How do mobile devices affect holiday shopping?
      p Shoppers using mobile devices to make holiday purchase decisions over Thanksgiving weekend:<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
    .text-block.two(data-animate="true")
      .number.large 51.4%
      p of all online visits during the 61-day period that ended on Dec. 31 were from smartphones.<span class="super"><a href="https://cmo.adobe.com/articles/2019/1/5-holiday-online-shopping-trends-to-guide-your-2019-strategy.html" target="_blank">5</a></span>
    .text-block.three(data-animate="true")
      h4 How many people visit holiday markets?
      h3 Nearly half
      p of all consumers attended a "retailtainment" event (like a pop-up shop or product demo) throughout the previous year. <br>When looking at just millennials, that number jumps to <span class="bold">66%</span>.<span class="super"><a href="https://nrf.com/media-center/press-releases/young-adults-most-likely-spend-more-holiday-season" target="_blank">6</a></span>
    .text-block.four(data-animate="true")
      .number.large 55%
      p of shoppers said that browsing for gift ideas is one of the main reasons to shop in&nbspstores.<span class="super"><a href="https://nrf.com/sites/default/files/2018-11/Natural-Insight-In-Store-Holiday-Shopping-2018.pdf" target="_blank">9</a></span>
    .text-block.five#evaluating
      h3 Evaluating Gift Options
    .text-block.six(data-animate="true")
      p Sellers are competing with an ever-growing marketplace, both online and offline. While product quality and user reviews are common ways for shoppers to vet their choices, they flock to holiday deals, with price discounts and promotional offers most likely to make them buy. Shoppers also rank complimentary shipping as another crucial element as they evaluate options.
    .text-block.seven(data-animate="true")
      h4 How do product photos impact buyer behavior?<span class="super"> 10</span>
      .mobile-wrap
        p According to Weebly data (Weebly survey of online shoppers ages 16&#8212;55 conducted in June 2018):
        .number.small 75%
        p of people rate photos as very influential when they’re deciding whether they want to buy a product online.
        .number.small 8 out of 10
        p shoppers expect to find photos on a website's product pages.
        .number.small 79%
        p expect to find product photos from multiple angles.
    .text-block.eight(data-animate="true")
      h4 How do product descriptions affect sales?<span class="super"> 11</span>
      p Products with 50 or more words in their descriptions — and fewer than 500  — tend to have <span class="bold">4X the number</span> of add-to-carts as products with shorter descriptions.
    EvaluatingOptions.desktop
    EvaluatingOptionsMobile.mobile
</template>

<script>
import EvaluatingOptions from '@/assets/img/svgs/evaluating-options.svg'
import EvaluatingOptionsMobile from '@/assets/img/svgs/evaluating-options-mobile.svg'
import AnimationManager from '../scripts/AnimationManager'


export default {
  name: 'evaluatingGiftOptions',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const pieCharts = this.$el.querySelectorAll('.pieChart')
    const getBars = this.$el.querySelectorAll('.animateRect')
    const getBarsMobile = this.$el.querySelectorAll('.animateRectMobile')
    const widths = [...getBars].map(el => el.getAttribute('width'))
    const mobileWidths = [...getBarsMobile].map(el => el.getAttribute('width'))
    const cursor = this.$el.querySelector('.cursor')

    this.desktopBarsAni = new TimelineLite({ paused: true })
    this.mobileBarsAni = new TimelineLite({ paused: true })
    this.cursorAni = new TimelineLite({paused: true})
      .fromTo(cursor, .5, { opacity: 0, y: 30, x: 30 }, { opacity: 1, y: 0, x: 0 })
 
    getBars.forEach((bar, i) => {
      this.desktopBarsAni
        .fromTo(bar, 1, {attr: { width: 0 } }, {attr:{ width: widths[i] } }, '-=0.75')
    })

    getBarsMobile.forEach((bar, i) => {
      this.mobileBarsAni
        .fromTo(bar, 1, {attr: { width: 0 } }, {attr:{ width: mobileWidths[i] } }, '-=0.75')
    })

    AnimationManager.onEnterView(this.$el, () => {
      this.desktopBarsAni.seek(0)
      this.desktopBarsAni.play()
      this.mobileBarsAni.seek(0)
      this.mobileBarsAni.play()
    })

    AnimationManager.onEnterView(cursor, () => {
      this.cursorAni.seek(0)
      this.cursorAni.play()
    })

    pieCharts.forEach((chart, i) => {
      const timeline = new TimelineLite({ paused: true })
        .set(chart, {strokeDasharray:700})
        .fromTo(chart, 1.5, {strokeDashoffset:700, strokeDasharray:700}, { strokeDashoffset:0, ease: Power0.easeNone }, 0.5)
      AnimationManager.onEnterView(chart, () => {
        timeline.seek(0)
        timeline.play()
      })
    });
  },
  computed: {
  },
  methods: {
  },
  components: {
    EvaluatingOptions,
    EvaluatingOptionsMobile,
  },
}
</script>

<style scoped lang="scss">
.evaluatingGiftOptions {
  position: relative;
  padding-left: 13%;
  padding-bottom: 6rem;

  .text-block {
    &.graph-info {
      left: 18%;
      top: 9.9%;
      width: 20.7%;
      height: 8.35%;
    }
    &.one {
      left: 18%;
      top: 3.5%;
      width: 21%;
      p {
        padding-right: 1rem;
      }
    }
    &.two {
      width: 16%;
      left: 62%;
      top: 12%;
    }
    &.three {
      left: 18%;
      top: 23%;
      width: 34%;
      h4 {
        margin-bottom: 3.5rem;
      }
      p, h2 {
        width: 60%;
      }
    }
    &.four {
      width: 19%;
      right: 19%;
      top: 40%;
    }
    &.five {
      left: 50%;
      bottom: 47%;
      transform: translateX(-50%);
      padding-top: 5rem;
    }
    &.six {
      left: 18%;
      bottom: 36%;
      width: 32%;
    }
    &.seven {
      right: 7%;
      bottom: 13%;
      width: 41%;
      h4 {
        width: 76%;
      }
      p {
        width: 67%;
        &:first-of-type {
          width: 90%;
        }
      }
    }
    &.eight {
      left: 18%;
      bottom: 3%;
      width: 26%;
    }
  }

  h4 {
    color: #000;
  }

  .bar {
    position: absolute;
    &.one {
      top: 0;
    }
    &.two {
      top: 38%;
    }
    &.three {
      top: 77%;      
    }

    h2 {
      padding-top: .9rem;
      padding-left: .9rem;
      color: #fff;
    }

    .title {
      font-size: 1.125rem;
      padding-top: .9rem;
      padding-left: .9rem;
    }
  }

  @media #{$mobile} {
    padding: 24rem 6rem 38rem 10rem;
    .text-block {
      &.graph-info {
        left: 10%;
        top: 8.4%;
        width: 20.7%;
        height: 9.7%;
      }
      &.one {
        top: 2%;
        width: 100%;
        left: 0;
        text-align: center;
        p {
          padding-right: 0;
          width: 45%;
          padding-top: 2rem;
          margin: 0 auto;
        }
      } 
       &.two {
        width: 40%;
        left: 49%;
        top: 14.25%;
      }
      &.three {
        top: 22%;
        left: 10%;
        width: 48%;
        h3 {
          padding-top: 2rem;
        }
        p {
          width: 82%;
          br {
            display: none;
          }
        }
      }
      &.four {
        width: 42%;
        right: auto;
        left: 10%;
        top: 34%;
      }
      &.five {
        left: 50%;
        bottom: 57%;
        transform: translateX(-50%);
        padding-top: 5rem;
      }
      &.six {
        left: 7%;
        bottom: 35%;
        width: 86%;
        text-align: center;
      }
      &.seven {
        bottom: 9%;
        width: 86%;
        h4 {
          position: relative;
          width: 46%;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }
      }
      &.eight {
        left: 18%;
        bottom: 2%;
        width: 65%;
        text-align: center;
        h4 {
          width: 50%;
          position: relative;
          margin: 0 auto;
          margin-bottom: 3rem;
        }
        p {
          width: 86%;
          margin: 0 auto;
        }
      }
    }

    .mobile-wrap {
      position: relative;
      left: 58%;
      width: 50%;
      padding-top: 4rem;
    }

    .bar {
    &.one {
      top: -2%;
    }
    &.two {
      top: 36%;
    }
    &.three {
      top: 74%;      
    }
    .title {
      font-size: 1.7rem;
    }
  }
  }
}
</style>
